export default [
  {
    name: 'JOA',
    path: '/joa',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Atualização de JOA',
        path: '',
        component: () => import('@/views/joa/Edit.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Atualização de JOA' }]
        }
      }
    ]
  }
];
